import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';

export const configToolsPlugin = createPlugin({
  id: 'workstation-configuration',
  routes: {
    root: rootRouteRef,
  },
});

export const WorkstationConfigurationTool = configToolsPlugin.provide(
  createRoutableExtension({
    name: 'WorkstationConfigurationTool',
    component: () =>
      import('./components/ToolConfigComponent').then(m => m.ExampleComponent),
    mountPoint: rootRouteRef,
  }),
);
